import { cn } from '@nexelem/utils';
import type { PropsWithChildren } from 'react';

type NodeLabelProps = {
  className?: string;
};

export const NodeLabel = ({ children, className }: PropsWithChildren<NodeLabelProps>) => (
  <span
    className={cn(
      'truncate border border-border-primary bg-surface-secondary px-0.5 text-s11-sb text-text-secondary-darker',
      className,
    )}
  >
    {children}
  </span>
);
